import { render, staticRenderFns } from "./MoreInformation.vue?vue&type=template&id=267fde6e"
import script from "./MoreInformation.vue?vue&type=script&lang=js"
export * from "./MoreInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports